import React, { useEffect, useState } from "react";
import { Col, Form, Row, Tab, Tabs } from "react-bootstrap";
import toast from "react-hot-toast";
import Select from "react-select";
import { useNavigate } from "react-router-dom";
import Delete from "../../../Components/Modals/DeleteModal";
import Navbar from "../../../Components/Navbar/Navbar";
import Table from "../../../Components/TableTemplate/Table";
import {
    numberFormat,
    refreshPage,
    toastStyle,
    getTodayDate,
    getType,
    TokenExpiry,
    selectDropdownStyle,
    getBranchId
} from "../../../Helpers/Utils/Common";
import DatePicker from "react-datepicker";
import Moment from "moment";

import { searchExpenses, deleteExpenses } from "../../../Helpers/apiCalls/Reports/DailyExpensesApi";
import { getAllBranches, searchBranch } from "../../../Helpers/apiCalls/Manage/Branches";
import Footer from "../../../Components/Footer/Footer";


export default function DailyExpenses() {
    let navigate = useNavigate();
    var dateToday = getTodayDate();
    const accountType = getType();
    const [inactive, setInactive] = useState(true);
    const [filterConfig, setFilterConfig] = useState({
        by_branch: 1,
        branch_id: (accountType === "branch_oic" || accountType === "branch_inventory_officer") ? getBranchId() : "",
    })
    const [branches, setBranches] = useState([]);
    const [showLoader, setShowLoader] = useState(false);
    const [expenses, setExpenses] = useState([]);
    const [totalAmount, setTotalAmount] = useState(0);
    const [isClicked, setIsClicked] = useState(false);

    const date = new Date();
    date.setDate(date.getDate() - 7);

    /* delete modal handler */
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const handleShowDeleteModal = () => setShowDeleteModal(true);
    const handleCloseDeleteModal = () => setShowDeleteModal(false); 
    const [selectedRow, setSelectedRow] = useState([]);
    const today = Moment().format("MM/DD/YYYY");
    const [branchOptions, setBranchOptions] = useState([]);

    // SEARCH USER
    function handleOnSearch(e) {
        const { name, value } = e.target;
        setFilterConfig((prev) => {
            return { ...prev, [name]: value };
        });
    }

    function handleSelectChange(e, row) {
        setSelectedRow(row);

        if (e.target.value === "view") {
            navigate("/dailyexpenses/view/" + row.branch_id, {
                state: { 
                    branch_id: row.branch_id,
                    date_from: row.expense_date, 
                    date_to: row.expense_date,
                },
            });
        } else if (e.target.value === "delete") {
            handleShowDeleteModal();
        }
    }


    function ActionBtn(row, type) {
        return (
            <Form.Select
                name="action"
                className="PO-select-action"
                onChange={(e) => handleSelectChange(e, row)}
            >
                <option value="" hidden selected>
                    Select
                </option>
                { accountType === "admin" ? (
                    <option value="view" className="color-options">
                        View
                    </option>
                    ): null
                }
                { accountType === "admin" ? (
                    <option value="delete" className="color-red">
                        Delete
                    </option>
                    ): null
                }
            </Form.Select>
        );
    }

    function ViewBtn(row) {
        return (
            <button
                name="action"
                className="btn btn-sm view-btn-table"
                id={row.id}
                onClick={() => handlePrint(row)}
                // value="payment-pi"
            >
                View
            </button>
        );
    }
    function handlePrint(row) {
        
        navigate("/dailyexpenses/view/" + row.branch_id, {
            state: { 
                branch_id: row.branch_id,
                date_from: row.expense_date, 
                date_to: row.expense_date,
            },
        });
    }

    const handleTabSelect = (tabKey) => {
        setFilterConfig((prev) => {
            return {
                ...prev,
                tab: tabKey,
                branch_id: "",
                date_from: "",
                date_to: "",
            };
        });
    };

    async function fetchBranches() {
        setBranches([]);

        const response = await getAllBranches();
        if (response.data) {
        var allBranches = response.data.data.data
            .filter((data) => {
            return data.is_franchise === "0";
            })
            .map((data) => {
            var branch = data;
            branch.label = data.name;
            branch.value = data.id;
            return branch;
            });
        if(accountType === "branch_oic" || accountType === "branch_inventory_officer") {
            var filteredBranch = allBranches.filter((data) => {
            return data.id === getBranchId()
            })
            setBranches(filteredBranch);
        } else {
            setBranches([{label: "All Branches", value:""}, ...allBranches]);
        }
        }
    }

    async function fetchData() {
        setShowLoader(true);
        setExpenses([])
        setTotalAmount(0)

        const response = await searchExpenses(filterConfig);

        if (response.error) {
        } else {
            var allBills = response.data.data.map((bill) => {
                var info = bill;
                info.grand_total = numberFormat(bill.grand_total)
                info.expense_date = Moment(bill.expense_date).format("MM-DD-YYYY")
                return info;
            });
            setExpenses(allBills)

            var total = response.data.total_expense? response.data.total_expense : "0";
            setTotalAmount(total);
        }
        setShowLoader(false);
    }

    async function handleDeleteExpense() {
        setIsClicked(true);
        
        const response = await deleteExpenses(selectedRow.id);
        if (response.data) {
            toast.success("Expense Deleted Successfully!", {
                style: toastStyle(),
            });
            setTimeout(() => refreshPage(), 1000);
        } else {
            toast.error("Error Deleting Expense", {
                style: toastStyle(),
            });
        }
    }

    useEffect(() => {
        fetchBranches();
    }, [filterConfig.tab]);

    useEffect(() => {
        fetchData();
    }, [filterConfig]);

    return (
        <div>
            <div className="page">
                <Navbar
                    onCollapse={(inactive) => {
                        setInactive(inactive);
                    }}
                    active={"DS REPORTS"}
                />
            </div>

            <div
                className={`manager-container ${
                    inactive ? "inactive" : "active"
                }`}
            >
                {/* headers */}
                <Row className="mb-4">
                    <Col xs={12} lg={7}>
                        <h1 className="page-title ps-2 ms-3 ms-md-0 ps-md-0 ms-md-0 fs-2"> DAILY EXPENSES </h1>
                    </Col>
                    <Col xs={12} lg={3} className="d-flex justify-content-end force-width flex-column flex-lg-row gap-3">
                        <input
                            type="search"
                            name="branch_name"
                            placeholder="Search branch name"
                            className="search-bar"
                            onChange={handleOnSearch}
                        />
                    </Col>
                    <Col lg={2} className="mt-4 mt-lg-0">
                        <div className="PO-filters">
                            <button
                                className="add-btn"
                                onClick={() => navigate("/dailyexpenses/add")}
                            >
                                Add
                            </button>
                        </div>
                    </Col>
                </Row>
                
                <div className="tab-content">
                    {/* filters */}
                    <div className="mb-3" />
                    <span className="ps-3 mb-2 align-middle d-none d-md-inline d-flex text-secondary">
                        Filter By:
                    </span>
                    <Row className="PO-filters flex flex-row mx-2 my-1">
                        <Col xs={12} lg={4} className="mb-2 mb-lg-0">
                        <Select
                            className="dropsearch-filter"
                            classNamePrefix="react-select"
                            placeholder="Select Branch"
                            // defaultValue={{label: "All Branches", value:""}}
                            styles={selectDropdownStyle}
                            // value={branch}
                            options={branches}
                            onChange={(e) => {
                            setFilterConfig((prev) => {
                                return {
                                    ...prev,
                                    branch_id: e.value,
                                };
                            })}}
                        />
                        </Col>
                        <Col xs={6} lg={2}>
                        <DatePicker
                                    autoComplete="off"
                            selected={filterConfig.date_from}
                            name="date_from"
                            placeholderText={Moment(date).format("MM/DD/YYYY")}
                            onChange={(date) => {
                                setFilterConfig((prev) => {
                                    return { ...prev, date_from: date };
                                });
                            }}
                            fixedHeight
                            className="date-filter me-4 form-control"
                            showYearDropdown
                            dateFormatCalendar="MMMM"
                            yearDropdownItemNumber={20}
                            scrollableYearDropdown
                        />
                        </Col>
                        <Col xs={6} lg={2}>
                        <DatePicker
                                    autoComplete="off"
                            selected={filterConfig.date_to}
                            name="date_to"
                            placeholderText={today}
                            onChange={(date) => {
                                setFilterConfig((prev) => {
                                    return { ...prev, date_to: date };
                                });
                            }}
                            fixedHeight
                            className="date-filter ps-label-content me-5 form-control"
                            showYearDropdown
                            dateFormatCalendar="MMMM"
                            yearDropdownItemNumber={20}
                            scrollableYearDropdown
                        />
                        </Col>
                    </Row>
                    <div className="mb-2" />
                    
                    <div className=" PO-filters d-flex justify-content-center">
                        <span className="me-4 ml-4 mt-2 ps-label">
                            Total Expenses: {numberFormat(totalAmount)}
                        </span>
                    </div>

                    <div className="below">
                        {/* table */}
                        <Table
                            tableHeaders={[
                                "-",
                                "DATE",
                                "BRANCH",
                                "AMOUNT",
                                "ADDED BY",
                                "APPROVED BY",
                                "STATUS",
                                "ACTIONS",
                            ]}
                            headerSelector={[
                                "-",
                                "expense_date",
                                "branch_name",
                                "grand_total",
                                "encoded_by_name",
                                "approved_by_name",
                                "status",
                            ]}
                            tableData={expenses}
                            ActionBtn={(row) => ActionBtn(row)}
                            ViewBtn={(row) => ViewBtn(row)}
                            showLoader={showLoader}
                        />
                    </div>
                    <div className="mb-2" />
                </div>
            </div>

            {/* modals */}
            <Delete
                show={showDeleteModal}
                onHide={handleCloseDeleteModal}
                text="expeses"
                onDelete={handleDeleteExpense}
                isClicked={isClicked}
            />
            <Footer/>
        </div>
    );
}
